(function(){
  var root=document.currentScript.closest('.tmx-pdp')||document;
  var data=document.getElementById('tmx-variants');
  if(!data) return;
  var variants=JSON.parse(data.textContent);
  var idInput=document.getElementById('tmx-variant-id');
  var selected={};
  document.querySelectorAll('.tmx-opt').forEach(function(opt){
    var idx=parseInt(opt.getAttribute('data-opt-index'),10);
    var sel=opt.querySelector('.tmx-opt__v.is-sel');
    if(sel) selected[idx]=sel.getAttribute('data-value');
    opt.querySelectorAll('.tmx-opt__v').forEach(function(btn){
      btn.addEventListener('click',function(){
        opt.querySelectorAll('.tmx-opt__v').forEach(function(b){b.classList.remove('is-sel');b.setAttribute('aria-pressed','false');});
        btn.classList.add('is-sel');btn.setAttribute('aria-pressed','true');
        selected[idx]=btn.getAttribute('data-value');
        var selEl=opt.querySelector('.tmx-opt__sel'); if(selEl) selEl.textContent=btn.getAttribute('data-value');
        update();
      });
    });
  });
  function fmt(cents){return '$'+(cents/100).toLocaleString('es-MX',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function update(){
    var match=variants.find(function(v){
      return v.options.every(function(o,i){return !(i in selected)||selected[i]===o;});
    });
    if(!match) return;
    idInput.value=match.id;
    var p=fmt(match.price);
    var pe=document.getElementById('tmx-price'); if(pe) pe.textContent=p;
    var ap=document.getElementById('tmx-atc-price'); if(ap) ap.textContent=p;
    var bp=document.getElementById('tmx-buybar-price'); if(bp) bp.textContent=p;
    var atc=document.getElementById('tmx-atc');
    if(atc){ if(match.available){atc.disabled=false; if(!document.getElementById('tmx-atc-price')){atc.innerHTML='Agregar al carrito — <span id="tmx-atc-price">'+p+'</span>';}}else{atc.disabled=true;atc.textContent='Agotado';} }
    if(match.featured_image){var mi=document.getElementById('tmx-main-img'); if(mi) mi.src=match.featured_image.src;}
  }
  document.querySelectorAll('.tmx-qty__b').forEach(function(b){
    b.addEventListener('click',function(){
      var inp=b.parentElement.querySelector('.tmx-qty__i');
      var n=parseInt(inp.value,10)||1; n+=parseInt(b.getAttribute('data-dir'),10); if(n<1)n=1; inp.value=n;
    });
  });
  document.querySelectorAll('.tmx-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      document.querySelectorAll('.tmx-thumb').forEach(function(x){x.classList.remove('is-sel');x.setAttribute('aria-selected','false');});
      t.classList.add('is-sel');t.setAttribute('aria-selected','true');
      var mi=document.getElementById('tmx-main-img'); if(mi) mi.src=t.getAttribute('data-full');
    });
  });
})();
